import { render, staticRenderFns } from "./myShop.vue?vue&type=template&id=670087e2&scoped=true"
import script from "./myShop.vue?vue&type=script&lang=js"
export * from "./myShop.vue?vue&type=script&lang=js"
import style0 from "./myShop.vue?vue&type=style&index=0&id=670087e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670087e2",
  null
  
)

export default component.exports